import { ValueOf } from "./utils";

export const CUSTOMER_TYPE = {
    NEW: "new",
    EXISTING: "existing",
    EXISTING_OTHER: "existing_other", // existing Telia number, but number is owned by another legal owner
    PORT_IN: "port_in",
    TRANSFER: "transfer",
    NEW_OR_PORT_IN: "neworportin",
} as const;

export type CustomerType = ValueOf<typeof CUSTOMER_TYPE>;

export const CHANGE_TYPE = {
    UPSELL: "Upsell",
    PROLONGING: "Prolonging",
    DOWNSELL: "Downsell",
} as const;

export type ChangeType = ValueOf<typeof CHANGE_TYPE>;
